import { defineMessages } from 'react-intl'

export const PreviewState = {
  ONLINE: 'online',
  AWAY: 'away'
}

export const Messages = defineMessages({
  typeMessage: {
    id: 'app.widget.placeholder',
    description: 'Composer placeholder',
    defaultMessage: 'Type your message...'
  },
  defaultWelcomeMessage: {
    id: 'app.widget.defaultWelcomeMessage',
    description: 'Message greeting that appears on the New Conversation screen',
    defaultMessage: 'How can we help out? We are here for you!',
  },
  defaultAwayMessage: {
    id: 'app.widget.defaultAwayMessage',
    description: 'Message shown to a user indicating that the Team is currently away or offline',
    defaultMessage: 'We’re not currently online right now but if you leave a message, we’ll get back to you as soon as possible!',
  },
})



// WEBPACK FOOTER //
// ./src/scripts/components/settings/ChatWidget/components/WelcomeMessage/constants.js